import { render } from "./banner.vue?vue&type=template&id=da88f986&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=da88f986&lang=less&scoped=true"

import exportComponent from "/Users/ym/Desktop/tianmuli/tml-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da88f986"]])

export default __exports__